module.exports = __webpack_public_path__ + "static/5c039160d1433203ee7aab04b5eda46be0c04a4e3c59f2834898e5feba3c5a35-6b4fa002bb3facf9881f497713b5e91d.png";